import { Component } from "react"
import type { CSSProperties, ErrorInfo, ReactNode } from "react"

interface Props {
  children: ReactNode
}

interface State {
  error: Error | null
  info: ErrorInfo | null
}

// Inline styles on purpose — this fallback must render even if the app's
// own stylesheet failed to load or is the thing that's broken.
const containerStyle: CSSProperties = {
  padding: 16,
  fontFamily: "monospace",
  fontSize: 13,
  whiteSpace: "pre-wrap",
  wordBreak: "break-all",
  background: "#fff",
  color: "#111",
  minHeight: "100vh",
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, info: null }

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ error, info })
  }

  render() {
    const { error, info } = this.state
    if (!error) return this.props.children
    return (
      <div style={containerStyle}>
        <h1 style={{ fontSize: 16, color: "#c00" }}>エラーが発生しました</h1>
        <p>{error.message}</p>
        <pre>{error.stack}</pre>
        {info?.componentStack && <pre>{info.componentStack}</pre>}
      </div>
    )
  }
}
